import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/info.png'


const _withScopeId = n => (_pushScopeId("data-v-b3a5052e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["content"]
const _hoisted_2 = ["content"]
const _hoisted_3 = ["content"]
const _hoisted_4 = {
  key: 0,
  style: {"--bs-breadcrumb-divider":"'•'"},
  "aria-label": "breadcrumb"
}
const _hoisted_5 = { class: "breadcrumb mb-0" }
const _hoisted_6 = { class: "breadcrumb-item" }
const _hoisted_7 = {
  class: "breadcrumb-item",
  "aria-current": "page"
}
const _hoisted_8 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-xl-9 col-lg-12" }
const _hoisted_11 = {
  class: "mod-description-card px-4 py-3 mb-3",
  id: "desc"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "description-preloader" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc-r" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc-r" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc-r-l" }, null, -1))
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "tags-wrapper d-flex flex-wrap align-items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "mod-info col d-flex flex-column fs-6" }
const _hoisted_24 = { class: "m-0" }
const _hoisted_25 = { style: {"color":"#6a6b6f"} }
const _hoisted_26 = { class: "m-0" }
const _hoisted_27 = { class: "m-0" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-black ms-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-eye" })
], -1))
const _hoisted_29 = { class: "m-0" }
const _hoisted_30 = { class: "mod-info col d-flex flex-column align-items-end" }
const _hoisted_31 = { class: "mb-1" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-heart" })
], -1))
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = {
  class: "mod-install-card px-4 py-4 mb-3",
  id: "install"
}
const _hoisted_35 = { class: "row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-icon col-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "info"
  })
], -1))
const _hoisted_37 = { class: "d-flex col flex-column text-justify" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "pb-1" }, "Как установить мод?", -1))
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = { class: "col-xl-3 col-lg-12 ps-xl-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Head = _resolveComponent("Head")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ModTitleComponent = _resolveComponent("ModTitleComponent")!
  const _component_ModTitlePreloaderComponent = _resolveComponent("ModTitlePreloaderComponent")!
  const _component_CarouselPreviewComponent = _resolveComponent("CarouselPreviewComponent")!
  const _component_AnchorMenuComponent = _resolveComponent("AnchorMenuComponent")!
  const _component_LikeButtonComponent = _resolveComponent("LikeButtonComponent")!
  const _component_DownloadComponent = _resolveComponent("DownloadComponent")!
  const _component_ModsArchiveComponent = _resolveComponent("ModsArchiveComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Head, null, {
      default: _withCtx(() => [
        _createElementVNode("title", null, _toDisplayString(_ctx.metaTitle), 1),
        _createElementVNode("meta", {
          name: "description",
          content: _ctx.metaDesc
        }, null, 8, _hoisted_1),
        _createElementVNode("meta", {
          property: "og:title",
          content: _ctx.metaTitle
        }, null, 8, _hoisted_2),
        _createElementVNode("meta", {
          property: "og:description",
          content: _ctx.metaDesc
        }, null, 8, _hoisted_3)
      ]),
      _: 1
    }),
    (!_ctx.preloaderShow)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_4, [
          _createElementVNode("ol", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createTextVNode("Главная")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: {name: 'mods', params: {game: _ctx.modData.game}, query: {page: 1}}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.getPrettyGame(_ctx.modData.game)), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.modData.title), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createVNode(_component_ModTitleComponent, {
          title: _ctx.modData.title,
          game: _ctx.modData.game,
          version: _ctx.modData.actual_version.version,
          author: _ctx.modData.author
        }, null, 8, ["title", "game", "version", "author"]), [
          [_vShow, !_ctx.preloaderShow]
        ]),
        _withDirectives(_createVNode(_component_ModTitlePreloaderComponent, null, null, 512), [
          [_vShow, _ctx.preloaderShow]
        ]),
        (_ctx.CarouselComp && !_ctx.preloaderShow)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.CarouselComp), {
              key: 0,
              images: _ctx.modData.images
            }, null, 8, ["images"]))
          : (_openBlock(), _createBlock(_component_CarouselPreviewComponent, { key: 1 })),
        _createVNode(_component_AnchorMenuComponent),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _withDirectives(_createElementVNode("div", {
            innerHTML: _ctx.modData.description,
            class: "no-style text-brake"
          }, null, 8, _hoisted_13), [
            [_vShow, !_ctx.preloaderShow]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_14, _hoisted_18, 512), [
            [_vShow, _ctx.preloaderShow]
          ]),
          _createElementVNode("div", {
            class: "mark-wrapper d-flex flex-wrap align-items-center mt-3",
            innerHTML: _ctx.carMarkBadge
          }, null, 8, _hoisted_19),
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modData.tags, (chip, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: index,
                class: "badge me-2 mb-2 d-flex align-items-center position-relative"
              }, [
                _createVNode(_component_router_link, {
                  class: "badge-link position-absolute",
                  to: {name: 'search',
                              query: {
                                query: chip,
                                page: 1
                              }
                         }
                }, null, 8, ["to"]),
                _createTextVNode(" " + _toDisplayString(chip), 1)
              ]))
            }), 128))
          ]),
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("p", _hoisted_24, [
                _createTextVNode("Опубликовано: "),
                _createElementVNode("small", _hoisted_25, _toDisplayString(_ctx.getStringTimestamp(_ctx.modData.timestamp)), 1)
              ]),
              _createElementVNode("p", _hoisted_26, [
                _createTextVNode("Автор: "),
                _createElementVNode("b", null, _toDisplayString(_ctx.modData.author), 1)
              ]),
              _createElementVNode("p", _hoisted_27, [
                _createTextVNode("Просмотров: " + _toDisplayString(_ctx.modData.views) + " ", 1),
                _hoisted_28
              ]),
              _createElementVNode("p", _hoisted_29, "Версия: " + _toDisplayString(_ctx.modData.actual_version.version), 1)
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("p", _hoisted_31, [
                _createTextVNode("Пользовательских оценок: "),
                _createElementVNode("b", null, _toDisplayString(_ctx.modData.likes), 1),
                _createTextVNode(),
                _hoisted_32
              ]),
              _createVNode(_component_LikeButtonComponent, {
                mod_id: _ctx.modData.id,
                onLikeMod: _ctx.likeMod
              }, null, 8, ["mod_id", "onLikeMod"])
            ])
          ])
        ]),
        (_ctx.VideoComp && _ctx.modData.video)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.VideoComp), { key: 2 }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  id: "video-wrapper",
                  innerHTML: _ctx.modData.video
                }, null, 8, _hoisted_33)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_DownloadComponent, {
          data: {
      downloads: _ctx.modData.downloads,
      version_id: _ctx.modData.actual_version.id,
      size: _ctx.modData.actual_version.size
    },
          title: _ctx.modData.title
        }, null, 8, ["data", "title"]),
        _createVNode(_component_ModsArchiveComponent, {
          archive_versions: _ctx.modData.archive_versions,
          title: _ctx.modData.title
        }, null, 8, ["archive_versions", "title"]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("div", {
                class: "mb-0 install-instruction",
                innerHTML: _ctx.getGameInstallInstruction(_ctx.modData.game)
              }, null, 8, _hoisted_39)
            ])
          ])
        ]),
        (_ctx.CommentsWrapper && !_ctx.preloaderShow)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.CommentsWrapper), {
              key: 3,
              mod_id: _ctx.modData.id
            }, null, 8, ["mod_id"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_40, [
        (_ctx.SimilarCards)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.SimilarCards), { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}